import { defineStore } from "pinia";

import { acknowledgeAlert } from "../functions/acknowledge-alert.js";

export const useAlertStore = defineStore("alert", {
  actions: {
    async acknowledgeAlert({ alertID, caseID, caseNumber }) {
      this.acknowledging = true;

      const result = await acknowledgeAlert({ alertID, caseID, caseNumber });

      if (result) {
        this.acknowledgedAt = Date.now();
      }

      this.acknowledging = false;
    },
  },
  state() {
    return {
      acknowledgedAt: null,
      acknowledgeButton:
        window.localStorage.getItem("acknowledgeButton") === "true",
      acknowledging: false,
      browserCommand: window.localStorage.getItem("browserCommand") || "",
      silenceButton: window.localStorage.getItem("silenceButton") === "true",
    };
  },
});
